import { render, staticRenderFns } from "./ModificarOrdenPago.vue?vue&type=template&id=c27ff052&scoped=true&"
import script from "./ModificarOrdenPago.vue?vue&type=script&lang=js&"
export * from "./ModificarOrdenPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27ff052",
  null
  
)

export default component.exports